import Navigation from '../modules/components/dashboard/navigation';
import Dropdown from '../modules/components/dashboard/dropdown';

import PhotoUpload from '../modules/components/dashboard/photo-upload';

import PersonalInfoForm from '../modules/forms/dashboard/personal-info';
import ProfileDeletionForm from '../modules/forms/dashboard/profile-deletion';
import ResetPasswordForm from '../modules/forms/dashboard/reset-password';
import ChangePasswordForm from '../modules/forms/dashboard/change-password';
import NotificationsSettingsForm from '../modules/forms/dashboard/notifications-settings';
import PaymentDetailsForm from '../modules/forms/dashboard/payment-details';

import ListingFilterForm from '../modules/forms/dashboard/listing-filter';
import ListingFilter from '../modules/components/dashboard/listing-filter';

export default function setDashboardScripts () {
    if (!window.location.pathname.includes('/dashboard/')) return;

    const path = window.location.pathname;

    const routes = {
        personalInformation: () => path === '/dashboard/account/',
        resetPassword: () => path === '/dashboard/reset-password/',
        notificationsSettings: () => path === '/dashboard/notifications-settings/',
        paymentDetails: () => path === '/dashboard/payment-details/',
        projects: () => path === '/dashboard/projects/',
        jobs: () => path === '/dashboard/jobs/',
    };

    if (!Object.values(routes).some((route) => route())) return;

    // Navigation

    new Navigation('.site-dashboard--navigation ul a');

    // Photo

    PhotoUpload();

    // Dropdown

    Dropdown('.notifications-form--dropdown[data-dropdown="internal"]');
    Dropdown('.notifications-form--dropdown[data-dropdown="email"]');

    // Forms

    if (routes.personalInformation()) {
        new PersonalInfoForm('#personal-info-form');
        new ProfileDeletionForm('#profile-deletion-form');
    }

    if (routes.resetPassword()) {
        new ResetPasswordForm('#reset-password-form');
        new ChangePasswordForm('#change-password-form');
    }

    if (routes.notificationsSettings()) {
        new NotificationsSettingsForm('#notifications-settings-form');
    }

    if (routes.paymentDetails()) {
        new PaymentDetailsForm('#payment-details-form');
    }

    if (routes.projects() || routes.jobs()) {
        new ListingFilterForm('#projects-filter-form');

        ListingFilter();
    }
}
